import { jsx as _jsx } from "react/jsx-runtime";
import { AppIcon, Theme } from '@streem/ui-react';
import { useEffect, useCallback } from 'react';
import { audio } from '../media/sounds';
export const useNotifyOfAudioOutputDeviceChange = ({ addNotification, removeNotification, }) => {
    const handleAudioOutputDeviceChanged = useCallback((audioOutputDevice) => {
        const notificationId = 'auto-audio-output-changed';
        addNotification({
            id: notificationId,
            message: `Speaker changed to ${audioOutputDevice.label}`,
            icon: _jsx(AppIcon, { color: Theme.colors.green50, name: "DoneIcon" }),
            useCloseButton: true,
            onActionClick: () => removeNotification(notificationId),
        });
    }, [addNotification, removeNotification]);
    useEffect(() => {
        audio.subscribeToAudioOutputDeviceChanged(handleAudioOutputDeviceChanged);
        return () => {
            audio.unsubscribeToAudioOutputDeviceChanged(handleAudioOutputDeviceChanged);
        };
    }, [handleAudioOutputDeviceChanged]);
};
//# sourceMappingURL=use_notify_of_audio_output_change.js.map